import { http } from "msw";

import { MOCK_LAB_RESULTS } from "@/mocks/data/lab-results";
import { withSession } from "@/mocks/resolvers";
import { successResponse } from "@/mocks/responses";

export const createProductHandlers = (webappUrl: string) => {
  return [
    http.get(
      `${webappUrl}/products/labs-results`,
      withSession(({ request }) => {
        const searchParams = new URL(request.url).searchParams;
        const perPage = Number(searchParams.get("perPage")) || MOCK_LAB_RESULTS.length;
        const currentPage = Number(searchParams.get("page")) || 1;
        const firstIndex = (currentPage - 1) * perPage;
        const page = MOCK_LAB_RESULTS.slice(firstIndex, firstIndex + perPage);

        return successResponse(page, {
          pagination: {
            count: page.length,
            total: MOCK_LAB_RESULTS.length,
            perPage,
            currentPage,
            totalPages: Math.ceil(MOCK_LAB_RESULTS.length / perPage),
            links: {},
          },
        });
      }),
    ),
  ];
};
